<template>
  <div class="airDetails" v-if="detailData">
    <div class="Details_data">
      <h5>创建时间: {{detailData.orderTime || detailData.appTime || '暂无'}}</h5>
      <div class="Details_text df">
        <span>订单号 : {{detailData.orderNo}}</span>
        <span>订单类型 : {{detailData.flightTypeTxt}}</span>
        <span>订单状态 : {{detailData.refStatusTxt || detailData.invStatusTxt || detailData.chaStatusTxt}}</span>
        <span>出票时间 : {{detailData.appTime || '暂无'}}</span>
        <span>票面总价 : {{ Number(detailData.payAmount).toFixed(2)}}</span>
      </div>
    </div>
    <div class="passenger" v-show="$route.query.type != 'Changing'">
      <h2>
        <p>{{type=='changPay'?'废票信息':'退票信息'}}</p>
      </h2>
      <el-row type="flex" class="passenger_top">
        <el-col :span="4">乘客姓名</el-col>
        <el-col :span="4">乘客类型</el-col>
        <el-col :span="6">证件号码</el-col>
        <el-col :span="4">出生年月</el-col>
        <el-col :span="6">票号</el-col>
      </el-row>
      <div class="passenger_body" v-for="(item,index) in detailData.passengers" :key="index">
        <div class="passengerD clear">
          <el-col :span="4">{{item.psgName}}</el-col>
          <el-col :span="4">
            <span v-if="item.psgType === '1'">成人</span>
            <span v-if="item.psgType === '2'">儿童</span>
            <span v-if="item.psgType === '3'">婴儿</span>
          </el-col>
          <el-col :span="6">{{item.cardNo}}</el-col>
          <el-col :span="4">{{item.birthday}}</el-col>
          <el-col :span="6">
            <p>{{item.initialTicketNumber}}</p>
          </el-col>
        </div>
        <div class="airList" v-for="(childItem,childIndex) in item.routeList" :key="childIndex">
          <div class="airList">
            <div class="airList_Top">
              <el-col :span="4">航班号</el-col>
              <el-col :span="3">航空公司</el-col>
              <el-col :span="3">航班日期</el-col>
              <el-col :span="4">出发地</el-col>
              <el-col :span="4">到达地</el-col>
              <el-col :span="2">舱位</el-col>
              <el-col :span="4">状态</el-col>
            </div>
            <div>
              <el-col :span="4">{{childItem.flightNo}}</el-col>
              <el-col :span="3">{{childItem.airCompanyName}}</el-col>
              <el-col :span="3">{{childItem.beginDate}}</el-col>
              <el-col :span="4">{{childItem.sCityName}}({{childItem.sCityCode}})</el-col>
              <el-col :span="4">{{childItem.eCityName}}({{childItem.eCityCode}})</el-col>
              <el-col :span="2">{{childItem.cabinCode}}</el-col>
              <el-col :span="4">
                <span>{{detailData.refStatus || detailData.invStatus==61?'处理中':detailData.invStatus==62?'已作废':
          detailData.invStatus==63?'废票失败':''}}</span>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.query.type == 'Changing'">
    <div class="passenger">
      <h2>
        <p>航班信息</p>
      </h2>
      <div  class="fare-list">
        <div class="air-list">
          <el-table
            :data="oldRouteList"
            style="width: 100%"
          >
            <!-- <el-table-column label="航程" align="center">
              <template slot-scope="scope">
                  {{scope.row.oldSegmentNo}}
              </template>
            </el-table-column> -->
            <el-table-column prop="oldFlightNo" label="航班号" align="center"></el-table-column>
            <el-table-column prop="oldCabinCode" label="舱位" align="center"></el-table-column>
            <el-table-column  label="起抵地" align="center" width="250">
               <template slot-scope="scope">
                 {{scope.row.oldSAirportName}}({{scope.row.oldSAirportCode}})/
                 {{scope.row.oldEAirportName}}({{scope.row.oldECityCode}})
               </template>
            </el-table-column>
            <el-table-column  label="起飞时间" align="center">
               <template slot-scope="scope">
                 {{scope.row.oldBeginDate}}/{{scope.row.oldBeginTime}}
               </template>
            </el-table-column>
            <el-table-column  label="到达时间" align="center">
               <template slot-scope="scope">
                 {{scope.row.oldArriveDate}}/{{scope.row.oldArriveTime}}
               </template>
            </el-table-column>
              <el-table-column  label="舱位等级" align="center">
               <template slot-scope="scope">
                 {{scope.row.oldCabinRank==1?'头等舱':
                 scope.row.oldCabinRank==2?'公务舱':
                 scope.row.oldCabinRank==3?'经济舱':'豪华经济舱'}}
               </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
     <div class="passenger">
      <h2>
        <p>改签航班信息</p>
      </h2>
      <div  class="fare-list">
        <div class="air-list">
          <el-table
            :data="newRouteList"
            style="width: 100%"
          >
            <!-- <el-table-column label="航程" width="60" align="center">
              <template slot-scope="scope">
                 {{scope.row.segmentNo}}
              </template>
            </el-table-column> -->
            <el-table-column  label="航班号" width="100" align="center">
              <template slot-scope="scope">
                {{scope.row.flightNo}}
              </template>
            </el-table-column>
            <el-table-column prop="cabinCode" label="舱位" align="center" width="80">
              <template slot-scope="scope">
                {{scope.row.cabinCode}}
              </template>
            </el-table-column>
            <el-table-column  label="出发地" align="center" width="140">
               <template slot-scope="scope">
                 {{scope.row.sAirportName}}{{scope.row.sAirportCode}}
               </template>
            </el-table-column>
            <el-table-column  label="到达地" align="center" width="140">
               <template slot-scope="scope">
                 {{scope.row.eAirportName}}{{scope.row.eAirportCode}}
               </template>
            </el-table-column>
            <el-table-column  label="起飞时间" align="center">
               <template slot-scope="scope">
                 {{scope.row.beginDate}} / {{scope.row.beginTime}}
               </template>
            </el-table-column>
            <el-table-column  label="到达时间" align="center" width="145">
               <template slot-scope="scope">
                  {{scope.row.arriveDate}} / {{scope.row.arriveTime}}
               </template>
            </el-table-column>
             <el-table-column  label="舱位等级" align="center">
               <template slot-scope="scope">
                 {{scope.row.cabinRank==1?'头等舱':
                 scope.row.cabinRank==2?'公务舱':
                 scope.row.cabinRank==3?'经济舱':'豪华经济舱'}}
               </template>
            </el-table-column>
             <!-- <el-table-column  label="备注" align="center">
               <template slot-scope="scope">
                 <el-input v-model="scope.row.remark"></el-input>
               </template>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
    </div>
    <div class="passenger">
      <h2>
        <p>改签乘客</p>
      </h2>
      <div  class="fare-list">
        <div class="air-list">
          <el-table
            :data="detailData.passengers"
            style="width: 100%"
          >
            <el-table-column label="姓名"  align="center">
              <template slot-scope="scope">
                  {{scope.row.psgName}}
              </template>
            </el-table-column>
            <el-table-column prop="flightNo" label="类型" width="120" align="center">
              <template slot-scope="scope">
                  {{scope.row.psgType==1?'成人':
                  scope.row.psgType==2?'儿童':'婴儿'}}
              </template>
            </el-table-column>
            <el-table-column label="原票号" align="center">
              <template slot-scope="scope">
                  {{scope.row.initialTicketNumber}}
              </template>
            </el-table-column>
            <!-- <el-table-column  label="电子行程单" align="center" prop="cabinCode">
            </el-table-column> -->
          </el-table>
        </div>
      </div>
    </div>
    <div class="passenger">
      <h2>
        <p>联系信息</p>
      </h2>
      <div class="relation-box flex-center-end">
          <div>
            <span>联系人:</span>
            <el-input v-model="detailData.contactName" readonly></el-input>
          </div>
           <div>
            <span>联系电话:</span>
            <el-input v-model="detailData.contactTel" readonly></el-input>
          </div>
           <div>
            <span>邮箱:</span>
            <el-input v-model="detailData.contactEmail" readonly></el-input>
          </div>
      </div>
      <div class="relation-box" style="padding-top:0">
          <p class="title">备注:</p>
          <el-input
            type="textarea"
            :rows="4"
            v-model="detailData.remark" readonly>
          </el-input>
      </div>
    </div>

    </div>
    <div v-show="$route.query.type != 'Changing'">
    <div class="passenger">
      <h2>
        <p>备注</p>
      </h2>
      <div style="padding:10px;">
        <el-input type="textarea" :autosize="{ minRows: 4}" v-model="detailData.remark" readonly/>
      </div>
    </div>
    <div class="passenger" v-if="detailData.resultTxt">
      <h2>
        <p>{{type=='changPay'?'废票结果':'退票结果'}}</p>
      </h2>
      <div class="relation-box">
        <p>{{detailData.resultTxt}}</p>
      </div>
    </div>
    </div>
    <div class="flex-center">
        <el-button type="small" @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
// 订单查询
import findVoidOrderDetail from "@/lib/data-service/flight/fligthInternationalAdmin/flight_inter_buyer_manage_order_findVoidOrderDetail.js";
import scrollTop from '@/lib/common-service/scrollTop'
import findRefundOrderDetail from "@/lib/data-service/flight/fligthInternationalAdmin/flight_inter_buyer_manage_order_findRefundOrderDetail.js";
import findChangeOrder from "@/lib/data-service/flight/fligthInternationalAdmin/findChangeOrderDetail";
export default {
  data() {
    return {
      detailData: null,
      orderNo: "",
      passengers: [],
      type:'',
      remark:''
    };
  },
  methods: {
    getDetail(){
      console.time("time1")
      let type = this.$route.query.type
      if(type=='changPay'){
          findVoidOrderDetail({ invalId : this.orderNo }).then(res => {
            this.detailData = res.data;
            this.$forceUpdate();
        })
      }
      else if(type=='Changing'){
        findChangeOrder({chaOrderId:this.orderNo}).then(res=>{
            this.detailData = res.data
            this.newRouteList = res.data.passengers[0].newRouteList
            this.oldRouteList =  res.data.passengers[0].oldRouteList
            console.log(res.data.passengers)
        })
      }
      else{
          findRefundOrderDetail({ refundOrderNo:this.orderNo }).then(res=>{
               this.detailData = res.data;
       })
      }
      console.timeEnd("time1")
    },
  },
  created() {
    if (this.$route.query.ordersNo) {
      this.orderNo = this.$route.query.ordersNo
      this.type = this.$route.query.type
      this.getDetail()
    }
  }
};
</script>
<style lang="less" scoped>
.airDetails {
  width: 100%;
}

.df {
  display: flex;
}
.Details_data {
  background: #fffcfa;
  border: solid 1px #ffb27f;
  h5 {
    padding-left: 30px;
    font-size: 14px;
    color: #666666;
    line-height: 32px;
    height: 32px;
    background: #fff5ef;
  }
  .Details_text {
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 30px;
    span {
      display: inline-block;
      width: 33%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 14px;
      color: #666;
      line-height: 25px;
      height: 25px;
    }
  }
}
.passenger,
.changing_box {
  border: 1px solid #e9e9e9;
  margin-bottom: 20px;
  margin-top: 20px;
  h2 {
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    background: #237dc8;
    color: #4b4b4b;
    padding-left: 8px;
    p {
      background-color: #ecf6ff;
      vertical-align: middle;
      padding-left: 20px;
    }
  }
  .passenger_top {
    padding: 0 15px;
    text-align: center;
    background: #f1f3f5;
    color: #666;
    line-height: 25px;
    font-size: 14px;
  }
  .passenger_body {
    padding: 0 15px;
  }
  .passengerD {
    // height: 40px;
    padding: 10px 0;
    background: #fff;
    font-size: 14px;
    // line-height: 40px;
    text-align: center;
    border-top: 1px solid #ececec;
    &:nth-child(1) {
      border-top: none;
    }
    > div {
      p {
        word-break: break-all;
        text-align: center;
      }
    }
  }
  .airList {
    border-top: 1px dashed #e9e9e9;
  }
  .airList {
    height: 60px;
    font-size: 12px;
    text-align: center;
    color: #999;
    > div {
      height: 30px;
      line-height: 30px;
    }
    .airList_Top {
      background: #ecf6ff;
      height: 20px;
      line-height: 20px;
    }
  }
  .changing {
    color: #237dc8;
    cursor: pointer;
  }
}
.price-list {
  border-bottom: 1px solid #ececec;
  text-align: center;
  padding: 10px;
  span {
    color: #ff6334;
  }
}
.text-warning {
  color: red;
  font-size: 14px;
  padding: 10px 40px;
}
.fare-list{
  width: 97%;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  border: 1px solid #e9e9e9;
  color: #666;
  .people-info{
     padding: 15px;
     background: #f1f3f5;
     span{
       padding: 0 15px;
     }
  }
  .air-list{
    padding: 10px 0;
    h4:nth-child(1){
      padding: 0 15px;
    }
  }
  /deep/.el-table{
    td{
      font-size: 12px;
    }
  }
}
.el-button{
  border-radius: 0;
}
.relation-box{
  padding: 20px 25px;
  font-size: 14px;
  color: #666;
  .title{
    padding: 10px 0;
  }
  div{
    display: flex;
    align-items: center;
    span{
      padding-right: 20px;
    }
    .el-input{
      width: 200px;
    }
  }
}
</style>
